import { render, staticRenderFns } from "./previewVideo.vue?vue&type=template&id=197a6062&scoped=true&"
import script from "./previewVideo.vue?vue&type=script&lang=js&"
export * from "./previewVideo.vue?vue&type=script&lang=js&"
import style0 from "./previewVideo.vue?vue&type=style&index=0&id=197a6062&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a6062",
  null
  
)

export default component.exports